import React from 'react';
import { Col, Row } from "react-bootstrap";
import { ArticleList } from "../../components/Articles/ArticleList";
import { StyledSectionHeader, StyledListContainer, StyledListSection } from "../../utils/common-styles";
import { Volunteering } from "../../components/Sidebar/General/Volunteering.jsx";
import { ReportIssue } from "../../components/Sidebar/General/ReportIssue.jsx";
import { BecomeAMember } from "../../components/Sidebar/General/BecomeAMember.jsx";
import { Helmet } from "react-helmet";
import { GenericSideBarTags } from "../../components/Sidebar/General/GenericSideBarTags";
import { UrlFixer } from "../../utils/utils";

export const ArticleListPage = () => {

    return (
        <>
            <Helmet>
                <title>Articles about Queen's Wood</title>
                <meta name="description" content="Articles about Queen's Wood" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Articles about Queen\'s Wood" />
                <meta property="og:description" content="Articles about Queen's Wood" />
                <meta property="og:url" content={`${window.location.origin}`} />
                <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
                <meta name="twitter:title" content="Articles about Queen\'s Wood" />
                <meta name="twitter:description" content="Articles about Queen's Wood" />
                <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
            </Helmet>
            <StyledSectionHeader>
                <div className="container">
                    <h1 className="section-title">About The Wood</h1>
                </div>
            </StyledSectionHeader>
            <StyledListSection>
                <StyledListContainer>
                    <Row>
                        <Col xs={12} md={9}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            <ArticleList /></Col>
                        <Col xs={12} md={3}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            <GenericSideBarTags tagLinkStem="/articles/list/tag" tagsToPreselect={[]} />
                            <ReportIssue />
                            <Volunteering />
                            <BecomeAMember />
                        </Col>
                    </Row>
                </StyledListContainer>
            </StyledListSection>
        </>
    )
}
